<template>
<el-container class="index-wrapper">
  <el-header :gutter="20" class="header-bar">
    <el-col :span="2">
      <img class="header-logo" src="@img/logo.jpg" />
    </el-col>
    <el-col :span="2" class="header-name">
      <el-row class="header-title">
        <span>筑</span>
        <span>梦</span>
        <span>高</span>
        <span>考</span>
      </el-row>
    </el-col>
    <el-col :span="10" class="header-search-wrapper">
      <el-autocomplete
        class="search-college"
        prefix-icon="el-icon-search"
        placeholder="查大学"
        @click.native="onSearch"
      />
    </el-col>
    <el-col :span="7" class="header-user-container">
      <UserHead/>
    </el-col>
  </el-header>
  
  <el-main class="main-body">
    <el-tabs v-model="activeTab" :stretch="true" class="nav-tab-bar">
      <el-tab-pane label="首页" name="home"><Home/></el-tab-pane>
      <el-tab-pane label="资讯" name="information"><Information/></el-tab-pane>
      <el-tab-pane label="消息" name="message"><Message/></el-tab-pane>
    </el-tabs>
  </el-main>

  <Foot/>

  <el-card class="customer-service-button" @click.native="onCustomerService">
    <div>联</div>
    <div>系</div>
    <div>客</div>
    <div>服</div>
  </el-card>

</el-container>
</template>

<script>
import {mapState} from 'vuex'
import Home from '@com/home/home'
import Foot from '@com/foot/foot'
import Information from '@com/information/information'
import Message from '@com/message/message'
import UserHead from '@com/index/UserHead'

export default {
  name: 'home',
  data () {
    return {
      activeTab: 'home',
      college: ''
    }
  },
  components:{
    Home,
    Foot,
    Information,
    Message,
    UserHead
  },
  computed: {
    // 将vuex中的全局变量userinfo、colleges映射为组件的局部变量
    ...mapState({
      userinfo: 'userinfo',
    }),
  },
  created () {
    document.title = '筑梦高考'
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    onSearch(){
      this.$router.push({ path: '/querycollege' })
    },
    onCustomerService(){
      //新页面方式打开客服
      const { href } = this.$router.resolve({
        path: `/customerservice`
      })
      window.open(href, "_blank")
    },
    
  },
}
</script>

<style lang="stylus" scoped>
.index-wrapper
  .header-bar
    margin: 50px 10px 20px 50px
    .header-logo
      width: 100px
      height: 100px
    .header-name
      height: 100px
      display: flex
      flex-direction: column
      justify-content: center
      .header-title
        font-size: 20px
        font-weight: bold
        display: flex
        justify-content: space-between
      .header-college
        width: 100%
        font-size: 10px
        display: flex
        justify-content: space-between
    .header-search-wrapper
      height: 100px
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      .search-college
        margin-left: 80px
        width: 400px
    .header-user-container
      height: 100px
      margin-left: 50px
  .main-body
    margin: 0px 10px 0px 50px
    .nav-tab-bar
      margin-top: 15px
      >>> .el-tabs__item
        font-size: 20px
  .customer-service-button
    position: fixed
    top: 40%
    left: 0px
    z-index: 200
    &:hover
      background-color: #eeeeee
      cursor: pointer


</style>